document.addEventListener('DOMContentLoaded', function () {

    // HEADER SCROLL ANIMATION — toggles one class, CSS handles the rest
    // Hysteresis: add at 162px, remove at 30px — prevents flicker near threshold
    const navInner = document.getElementById("nav-inner");
    if (navInner) {
        let ticking = false;
        let isScrolled = false;
        window.addEventListener("scroll", function () {
            if (!ticking) {
                requestAnimationFrame(function () {
                    var y = window.scrollY;
                    if (!isScrolled && y > 162) {
                        navInner.classList.add("is-scrolled");
                        isScrolled = true;
                    } else if (isScrolled && y < 30) {
                        navInner.classList.remove("is-scrolled");
                        isScrolled = false;
                    }
                    ticking = false;
                });
                ticking = true;
            }
        });
    }


    const openMenuBtn = document.querySelector('[data-collapse-toggle="navbar-user"]');
    const closeMenuBtn = document.getElementById('close-menu');
    const menu = document.getElementById('navbar-user');

    const mobSearchSlot = document.getElementById('mob-search-show');
    const mobileSearchWrapper = document.getElementById('mobile-search-wrapper');
    const mobileSearchDesktopSlot = mobileSearchWrapper?.parentElement;

    const mobLangSlot = document.getElementById('mob-lang-show');
    const langDesktopSlot = document.getElementById('lang-desktop-slot');
    const langBtn = document.getElementById('lang-btn');
    const langMenuList = document.getElementById('lang-menu');

    const mobDonateBtnSlot = document.getElementById('mob-btn-show');
    const donateDesktopSlot = document.getElementById('donate-btn-desktop-slot');
    const donateBtn = document.getElementById('donate-btn');

    if (openMenuBtn && closeMenuBtn && menu) {

        const moveToMobile = () => {

            if (mobSearchSlot && mobileSearchWrapper) {
                mobSearchSlot.classList.remove('hidden');
                mobileSearchWrapper.classList.remove('hidden');
                mobSearchSlot.append(mobileSearchWrapper);
            }

            if (mobLangSlot && langBtn) {
                mobLangSlot.classList.remove('hidden');
                langBtn.classList.remove('hidden');
                mobLangSlot.append(langBtn);
            }

            if (mobDonateBtnSlot && donateBtn) {
                mobDonateBtnSlot.classList.remove('hidden');
                mobDonateBtnSlot.append(donateBtn);

                donateBtn.classList.remove('py-2', 'px-4');
                donateBtn.classList.add('py-4', 'px-6');
            }

        };

        const moveToDesktop = () => {

            if (mobSearchSlot && mobileSearchWrapper && mobileSearchDesktopSlot) {
                mobSearchSlot.classList.add('hidden');
                mobileSearchWrapper.classList.add('hidden');
                mobileSearchDesktopSlot.prepend(mobileSearchWrapper);
            }

            if (mobLangSlot && langBtn && langDesktopSlot) {
                mobLangSlot.classList.add('hidden');
                langBtn.classList.remove('hidden');
                langDesktopSlot.append(langBtn);
            }

            if (mobDonateBtnSlot && donateBtn && donateDesktopSlot) {
                mobDonateBtnSlot.classList.add('hidden');
                donateDesktopSlot.prepend(donateBtn);

                donateBtn.classList.remove('py-4', 'px-6');
                donateBtn.classList.add('py-2', 'px-4');
            }

        };

        // OPEN MENU
        openMenuBtn.addEventListener('click', () => {

            menu.classList.remove('translate-x-full');
            openMenuBtn.setAttribute('aria-expanded', 'true');

            if (window.innerWidth < 1024) {
                moveToMobile();
            }

        });

        // CLOSE MENU
        closeMenuBtn.addEventListener('click', () => {

            menu.classList.add('translate-x-full');
            openMenuBtn.setAttribute('aria-expanded', 'false');

            if (window.innerWidth < 1024) {
                moveToDesktop();
            }

        });

        // RESET STATE OF MEGAMENU
        function resetMegaMenus() {
            document.querySelectorAll('.mega-menu').forEach((menuEl) => {
                menuEl.classList.remove('max-h-[1000px]');
                menuEl.classList.add('max-h-0');
                menuEl.classList.add('opacity-0');
                menuEl.classList.add('pointer-events-none');
            });
            document.querySelectorAll('.mega-arrow').forEach((arrowEl) => {
                arrowEl.classList.remove('rotate-180');
            });

            // RESET LANGUAGE DROPDOWN WHILE RESIZE THE SCREEN
            if (langMenuList) {
                langMenuList.classList.remove('max-h-[1000px]');
                langMenuList.classList.add('opacity-0');
                langMenuList.classList.add('pointer-events-none');
            }
        }

        // DESKTOP HOVER FOR LANGUAGE MENU
        function setupLangHover() {
            if (!langBtn || !langMenuList) return;
            if (window.innerWidth >= 1024) {
                let timeout;
                langBtn.onmouseenter = () => {
                    clearTimeout(timeout);
                    langMenuList.classList.remove('opacity-0', 'pointer-events-none');
                    langMenuList.classList.add('opacity-100');
                };
                langBtn.onmouseleave = () => {
                    timeout = setTimeout(() => {
                        langMenuList.classList.remove('opacity-100');
                        langMenuList.classList.add('opacity-0', 'pointer-events-none');
                    }, 100);
                };
            } else {
                langBtn.onmouseenter = null;
                langBtn.onmouseleave = null;
            }
        }

        // Run on load
        setupLangHover();

        // RUN ON RESIZE
        window.addEventListener('resize', () => {

            if (window.innerWidth >= 1024) {
                moveToDesktop();
                menu.classList.add('translate-x-full');
                openMenuBtn.setAttribute('aria-expanded', 'false');
                resetMegaMenus();
            }

            setupLangHover();
        });
    }


    // Select all buttons that trigger the mega menu
    // This click event only works for mobile
    document.querySelectorAll('.mega-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
            if (window.innerWidth >= 1024) return;

            const item = btn.closest('.mega-item');
            const megaMenu = item?.querySelector('.mega-menu');
            const arrow = item?.querySelector('.mega-arrow');

            if (!megaMenu) return;

            // Check if the clicked menu is currently open
            const isOpen = megaMenu.classList.contains('max-h-[1000px]');
            // Close all mega menus
            document.querySelectorAll('.mega-menu').forEach((menuEl) => {
                menuEl.classList.remove('max-h-[1000px]');
                menuEl.classList.add('max-h-0');
                menuEl.classList.add('opacity-0');
                menuEl.classList.add('pointer-events-none');
            });

            // Reset all arrow rotations
            document.querySelectorAll('.mega-arrow').forEach((arrowEl) => {
                arrowEl.classList.remove('rotate-180');
            });

            // If the clicked menu was closed, open it
            if (!isOpen) {
                megaMenu.classList.remove('max-h-0', 'opacity-0', 'pointer-events-none');
                megaMenu.classList.add('max-h-[1000px]');
                arrow?.classList.add('rotate-180');
            }
        });
    });

    // SEARCH MODAL TOGGLE
    function initSearchModal() {
        const desktopToggle = document.getElementById('search-toggle');
        const mobileToggle = document.getElementById('mobile-search-toggle');

        const modal = document.getElementById('search-modal');
        const closeBtn = document.getElementById('search-close');
        const searchInput = document.getElementById('search-input');
        const modalBox = modal?.querySelector('div');

        if (!modal || !closeBtn || !searchInput || !modalBox) return;

        function openModal() {
            modal.classList.remove('opacity-0', 'pointer-events-none');
            modal.classList.add('opacity-100');
            modalBox.classList.remove('scale-95');
            modalBox.classList.add('scale-100');
        }

        function closeModal() {
            modal.classList.add('opacity-0', 'pointer-events-none');
            modal.classList.remove('opacity-100');
            modalBox.classList.add('scale-95');
            modalBox.classList.remove('scale-100');
        }

        desktopToggle?.addEventListener('click', openModal);
        mobileToggle?.addEventListener('click', openModal);
        closeBtn.addEventListener('click', closeModal);

        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeModal();
        });
    }

    initSearchModal();



    // Accordian Toggle
    document.querySelectorAll('.cta-wrapper').forEach(wrapper => {

        const header = wrapper.querySelector('.cta-toggle');
        const content = wrapper.querySelector('.cta-content');
        const icon = wrapper.querySelector('.cta-icon');
        const circle = wrapper.querySelector('.cta-circle');
        const circleDark = wrapper.querySelector('.cta-circle-dark');
        const plus = wrapper.querySelector('.cta-plus');

        if (!header || !content) return;

        let isOpen = false;

        header.addEventListener('click', (e) => {

            e.stopPropagation();

            // CLOSE OTHERS (same as your code)
            document.querySelectorAll('.cta-wrapper').forEach(other => {
                if (other !== wrapper) {
                    const otherContent = other.querySelector('.cta-content');
                    const otherIcon = other.querySelector('.cta-icon');
                    const otherCircle = other.querySelector('.cta-circle');
                    const otherCircleDark = other.querySelector('.cta-circle-dark');
                    const otherPlus = other.querySelector('.cta-plus');
                    const otherHeader = other.querySelector('.cta-toggle');

                    if (otherContent) {
                        otherContent.style.maxHeight = "0px";
                        otherContent.classList.remove('opacity-100', 'mt-4');
                        otherContent.classList.add('opacity-0', 'mt-0');
                    }

                    if (otherIcon) otherIcon.classList.remove('rotate-45');
                    if (otherCircle) otherCircle.classList.remove('opacity-0');

                    if (otherCircleDark) {
                        otherCircleDark.classList.add('opacity-0', 'scale-0');
                    }

                    if (otherPlus) {
                        otherPlus.classList.remove('fill-[#F8F4E4]');
                        otherPlus.classList.add('fill-[#4F3838]');
                    }

                    if (otherHeader) {
                        otherHeader.classList.remove('bg-transparent');
                        otherHeader.classList.add('bg-[#CFB091]');
                    }

                    other.classList.remove('border-2', 'border-[#513937]', 'rounded-xl');
                }
            });

            // TOGGLE CURRENT
            isOpen = content.style.maxHeight && content.style.maxHeight !== "0px";

            if (isOpen) {
                content.style.maxHeight = "0px";
                content.classList.remove('opacity-100', 'mt-4');
                content.classList.add('opacity-0', 'mt-0');
                icon.classList.remove('rotate-45');
            } else {
                // content.style.maxHeight = content.scrollHeight + "px";
                content.style.maxHeight = "100%";
                content.classList.remove('opacity-0', 'mt-0');
                content.classList.add('opacity-100', 'mt-4');
                icon.classList.add('rotate-45');
            }

            circle.classList.toggle('opacity-0');
            circleDark.classList.toggle('opacity-0');
            circleDark.classList.toggle('scale-0');

            plus.classList.toggle('fill-[#F8F4E4]');
            plus.classList.toggle('fill-[#4F3838]');

            // apply background to full header
            header.classList.toggle('bg-transparent');
            header.classList.toggle('bg-[#CFB091]');

            wrapper.classList.toggle('border-2');
            wrapper.classList.toggle('border-[#513937]');
            wrapper.classList.toggle('rounded-xl');
        });
    });

    // Pantheon cache-varying cookies must match: STYXKEY[a-zA-Z0-9_-]+
    function normalizePantheonCookieName(name) {
        let normalized = String(name).replace(/[^a-zA-Z0-9_-]/g, '_');

        if (!normalized.startsWith('STYXKEY')) {
            normalized = `STYXKEY_${normalized}`;
        }

        return normalized;
    }

    // helper: set cookie
    function setCookie(name, value, days = 7) {
        const cookieName = normalizePantheonCookieName(name);
        const safeDays = Number.isFinite(days) ? Math.max(0, Math.floor(days)) : 7;
        const maxAge = Math.max(0, safeDays * 24 * 60 * 60);
        const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
        const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';

        document.cookie =
            `${cookieName}=${encodeURIComponent(value)}; ` +
            `max-age=${maxAge}; expires=${expires}; path=/; SameSite=Lax${secureFlag}`;
    }

    // helper: get cookie
    function getCookie(name) {
        const cookieName = normalizePantheonCookieName(name);
        const nameEQ = `${cookieName}=`;
        const cookies = document.cookie ? document.cookie.split(';') : [];

        for (let c of cookies) {
            c = c.trim();
            if (c.startsWith(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }


    // TOPBAR CLOSE — hide for 1 day
    const topbarClose = document.getElementById('topbarclose');
    const topbarSection = document.querySelector('.secondary-popup-on-load');
    if (topbarClose && topbarSection) {
        // check cookie
        if (getCookie('topbar_dismissed') === '1') {
            topbarSection.style.display = 'none';
        } else {
            topbarClose.addEventListener('click', () => {
                topbarSection.style.display = 'none';
                setCookie('topbar_dismissed', '1', 7);
            });
        }
    }

    // THE SECONDARY POPUP, SHOW SVG WHEN SCROLL 
    document.addEventListener('scroll', () => {
        if (document.querySelector('.divider-svg')) {
            const divider = document.querySelector('.divider-svg');
            if (window.scrollY > 50) {
                divider.classList.add('opacity-100');
            } else {
                divider.classList.remove('opacity-100');
            }
        }
    });

    // Popup First-time visitor
    window.addEventListener('load', () => {

        const popup = document.getElementById('popupOverlay');

        if (!popup) return;

        // Check if popup was dismissed via cookie
        if (getCookie('popup_dismissed') === '1') return;

        // Show popup (with delay)
        setTimeout(() => {
            popup.classList.remove('opacity-0', 'pointer-events-none');
        }, 500);

        function dismissPopup() {
            popup.classList.add('opacity-0', 'pointer-events-none');
        }

        function dismissPopupWithCookie() {
            dismissPopup();
            // var d = new Date();
            // d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);
            // document.cookie = 'popup_dismissed=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';

            setCookie('popup_dismissed', '1', 30);
        }

        // Desktop close sets a 7-day cookie
        const desktopCloseBtn = document.getElementById('popupCloseDesktop');
        if (desktopCloseBtn) {
            desktopCloseBtn.addEventListener('click', dismissPopupWithCookie);
        }

        // Other close button (session only)
        const closeBtn = document.getElementById('popupClose');
        if (closeBtn) {
            //closeBtn.addEventListener('click', dismissPopup);
            closeBtn.addEventListener('click', dismissPopupWithCookie);
        }

        // CLICK OUTSIDE TO CLOSE
        popup.addEventListener('click', (e) => {
            if (e.target === popup) {
                dismissPopup();
            }
        });

        // CTA elements with data-action="closepopup"
        popup.querySelectorAll('[data-action="closepopup"]').forEach((el) => {
            el.addEventListener('click', (e) => {
                if (el.tagName === 'a') {
                    e.preventDefault();
                    dismissPopupWithCookie();
                    const href = el.getAttribute('href');
                    if (href && href !== '#') {
                        setTimeout(() => { window.location.href = href; }, 300);
                    }
                } else {
                    dismissPopupWithCookie();
                }
            });
        });

    });

    // FORMS — add .has-value to fields with content (for floating labels)
    document.querySelectorAll(`
        .gfield input, .gfield textarea, .gfield select,
        .form-row input, .form-row textarea, .form-row select
    `).forEach(el => {

        const field =
            el.closest('.ginput_complex span') ||
            el.closest('.gfield') ||
            el.closest('.form-row');

        if (!field) return;

        const update = () => {
            let hasValue;

            if (el.type === 'checkbox' || el.type === 'radio') {
                hasValue = el.checked;
            } else {
                hasValue = el.value && el.value.trim() !== '';
            }

            field.classList.toggle('has-value', hasValue);
        };

        update();
        el.addEventListener('input', update);
        el.addEventListener('change', update);
    });

    // common arrow toggle for select boxes (not just gravity forms)
    document.querySelectorAll('select').forEach(select => {

        const wrapper =
            select.closest('.woocommerce-input-wrapper') ||  // WooCommerce
            select.closest('.ginput_container_select') ||   // Gravity
            select.closest('.ginput_address_country') ||    // Gravity
            select.closest('.select-wrapper') ||            // Custom
            select.parentElement;                           // fallback

        if (!wrapper) return;

        select.addEventListener('click', (e) => {
            e.stopPropagation();

            // close all
            document.querySelectorAll('.open')
                .forEach(el => el.classList.remove('open'));

            wrapper.classList.add('open');
        });

        select.addEventListener('change', () => {
            setTimeout(() => wrapper.classList.remove('open'), 150);
        });
    });


    // one global outside click
    document.addEventListener('click', () => {
        document.querySelectorAll('.open')
            .forEach(el => el.classList.remove('open'));
    });

    document.querySelectorAll('.gfield_checkbox input[type="checkbox"], .gfield--type-consent input[type="checkbox"], .woocommerce-input-wrapper input[type="checkbox"]').forEach(input => {
        const label = input.closest('label');
        if (!label) return;

        // Prevent duplicate
        // if (label.querySelector('.spana-checkbox')) return;

        const span = document.createElement('span');
        span.classList.add('spana-checkbox');

        // ALWAYS place right after input
        input.insertAdjacentElement('afterend', span);
    });


    document.querySelectorAll('.gfield_radio .gchoice').forEach(choice => {
        const input = choice.querySelector('input[type="radio"]');
        const label = choice.querySelector('label');

        if (!choice.querySelector('.spana-radio')) {
            const span = document.createElement('span');
            span.classList.add('spana-radio');

            input.after(span);
        }
    });





    const contactFormToggle = document.querySelector('.contact-form-accordion-toggle');
    const contactFormContent = document.querySelector('.contact-form-accordion-content');
    const contactFormArrow = document.querySelector('.contact-form-accordion-arrow');

    if (contactFormToggle && contactFormContent && contactFormArrow) {
        contactFormToggle.addEventListener('click', () => {

            if (contactFormContent.style.maxHeight) {
                contactFormContent.style.maxHeight = null;
                contactFormArrow.classList.remove('rotate-180');
                contactFormToggle.setAttribute("aria-expanded", "false");
            } else {
                contactFormContent.style.maxHeight = contactFormContent.scrollHeight + "px";
                contactFormArrow.classList.add('rotate-180');
                contactFormToggle.setAttribute("aria-expanded", "true");
            }

        });
    }




    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function') {
        const $ = window.jQuery;
        const $sliders = jQuery('.product-slider .slider');

        if ($sliders.length) {
            $sliders.each(function () {
                const $slider = jQuery(this);

                if ($slider.hasClass('slick-initialized')) {
                    return;
                }

                const $sliderSection = $slider.closest('.product-slider');
                let $sliderNavigation = $sliderSection.find('.slider-navigation').first();
                const productCount = $slider.children().length;

                console.info('[Shop slider] Product cards found:', productCount);

                const prevArrowSvg = '<button class="slick-prev" type="button" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#clip0_shop_prev_fallback)"><path d="M33.8557 6.1441C41.5117 13.8001 41.5117 26.2081 33.8557 33.8641C26.1997 41.5201 13.7917 41.5201 6.13566 33.8641C-1.52034 26.2081 -1.52034 13.8001 6.13566 6.1441C13.7917 -1.5119 26.1997 -1.5119 33.8557 6.1441Z" fill="#513937"/><path d="M19.1833 31.6401L20.8473 29.9841L12.1513 21.2641L32.3033 21.0321L32.2793 18.6801L12.2233 18.9121L21.0953 10.0161L19.4313 8.36011L7.69531 20.1201L19.1833 31.6401Z" fill="#F8F4E4"/></g><defs><clipPath id="clip0_shop_prev_fallback"><rect width="40" height="40" fill="white" transform="translate(40 1.74846e-06) rotate(90)"/></clipPath></defs></svg></button>';
                const nextArrowSvg = '<button class="slick-next" type="button" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#clip0_shop_next_fallback)"><path d="M33.8557 6.1441C41.5117 13.8001 41.5117 26.2081 33.8557 33.8641C26.1997 41.5201 13.7917 41.5201 6.13566 33.8641C-1.52034 26.2081 -1.52034 13.8001 6.13566 6.1441C13.7917 -1.5119 26.1997 -1.5119 33.8557 6.1441Z" fill="#513937"/><path d="M20.8167 31.6401L19.1527 29.9841L27.8487 21.2641L7.69669 21.0321L7.72069 18.6801L27.7767 18.9121L18.9047 10.0161L20.5687 8.36011L32.3047 20.1201L20.8167 31.6401Z" fill="#F8F4E4"/></g><defs><clipPath id="clip0_shop_next_fallback"><rect width="40" height="40" fill="white" transform="translate(40 1.74846e-06) rotate(90)"/></clipPath></defs></svg></button>';

                if (!$sliderNavigation.length) {
                    $sliderNavigation = jQuery(
                        '<div class="slider-navigation flex items-center justify-center gap-5 mt-10">' +
                        prevArrowSvg +
                        '<ul class="dots flex items-center justify-center gap-2"></ul>' +
                        nextArrowSvg +
                        '</div>'
                    );
                    $sliderSection.append($sliderNavigation);
                }
                const $prevArrow = $sliderNavigation.find('.slick-prev').first();
                const $nextArrow = $sliderNavigation.find('.slick-next').first();
                const $dots = $sliderNavigation.find('.dots').first();

                const prevArrowMarkup = $prevArrow.length
                    ? $prevArrow.prop('outerHTML')
                    : prevArrowSvg;
                const nextArrowMarkup = $nextArrow.length
                    ? $nextArrow.prop('outerHTML')
                    : nextArrowSvg;

                if ($prevArrow.length) {
                    $prevArrow.remove();
                }

                if ($nextArrow.length) {
                    $nextArrow.remove();
                }

                $slider.slick({
                    centerMode: false,
                    infinite: productCount > 4,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    centerPadding: '0px',
                    autoplay: true,
                    autoplaySpeed: 4000,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    pauseOnDotsHover: false,
                    speed: 500,
                    swipe: true,
                    swipeToSlide: true,
                    draggable: true,
                    waitForAnimate: false,
                    arrows: true,
                    dots: true,
                    appendArrows: $sliderNavigation,
                    appendDots: $dots,
                    prevArrow: prevArrowMarkup,
                    nextArrow: nextArrowMarkup,
                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                infinite: productCount > 3,
                                slidesToShow: 3,
                                centerPadding: '0px'
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                infinite: productCount > 2,
                                slidesToShow: 2,
                                centerPadding: '0px'
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                infinite: productCount > 2,
                                slidesToShow: 2,
                                centerPadding: '0px'
                            }
                        }
                    ]
                });

                $slider.on('click', '.slick-slide', function () {
                    const index = jQuery(this).data('slick-index');
                    $slider.slick('slickGoTo', index).slick('slickPlay');
                });
            });
        }
    } else if (window.jQuery) {
        const $ = window.jQuery;
        const $sliders = jQuery('.product-slider .slider');

        if ($sliders.length) {
            $sliders.addClass('grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4');
            jQuery('.product-slider .slider-navigation').addClass('hidden');
        }
    }


    if (window.jQuery) {
        const $ = window.jQuery;

        jQuery('.variation-Discount').closest('tr').find('.product-quantity').html('<div class="minusbtn"><button disabled type="button" class="minus">-</button></div><div class="quantity"><input type="number" readonly class="input-text qty text" value="1" title="Qty" size="4"></div><div class="plusbtn"><button disabled type="button" class="plus">+</button></div>');

        jQuery('#billing_country').on('change', function () {
            jQuery('.checkout-loader').show();
            jQuery(document.body).one('updated_checkout', function () {
                window.location.reload();
            });
            jQuery(document.body).trigger('update_checkout');
        });

        const $paypalButton = jQuery('.ppcp-dcc-order-button');
        if ($paypalButton.length) {
            const $checkbox = jQuery('input.woocommerce-form__input.woocommerce-form__input-checkbox, #terms');

            if ($checkbox.length) {
                const togglePaypalButton = function () {
                    $paypalButton.prop('disabled', !$checkbox.is(':checked'));
                };

                togglePaypalButton();
                $checkbox.on('change', togglePaypalButton);
            } else {
                $paypalButton.prop('disabled', true);
            }
        }

        jQuery('.wdgk_donation').prop('type', 'number');

        if (jQuery('.bannertext').length) {
            const greenBlockImageUrl = (window.location.origin || '') + '/wp-content/themes/workinganimals-content/images/greenblock.png';

            const calcBannerSize = function () {
                const bannerTextWidth = jQuery('.bannertext').width();
                jQuery('.bannertext').css('--banner-text-width', bannerTextWidth + 'px');

                const bannerTextAfterStyle = `
                    position: absolute;
                    content: "";
                    background: url('${greenBlockImageUrl}') no-repeat;
                    background-size: 100% 100%;
                    width: calc(150% + var(--banner-text-width) + 55px)!important;
                    height: 100%;
                    left: -150%;
                    top: 0;
                    z-index: -1;
                    `;

                jQuery('.bannertext').prev('style').remove();
                jQuery('.bannertext').before('<style>.bannertext::after {' + bannerTextAfterStyle + '}</style>');
            };

            calcBannerSize();
            jQuery(window).on('resize', calcBannerSize);
        }
    }



    // ========== WOOCOMMERCE SLICK SLIDERS ==========

    // Slick slider for .giftscarousel
    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function') {
        jQuery('.giftscarousel').slick({
            dots: true,
            infinite: true,
            speed: 500,
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#cp)"><path d="M33.86 6.14c7.65 7.66 7.65 20.07 0 27.72-7.66 7.66-20.07 7.66-27.72 0-7.66-7.66-7.66-20.07 0-27.72 7.65-7.66 20.06-7.66 27.72 0Z" fill="#513937"/><path d="M19.18 31.64l1.66-1.66-8.7-8.72 20.16-.23-.02-2.35-20.06.23 8.87-8.9-1.66-1.65L7.7 20.12l11.49 11.52Z" fill="#F8F4E4"/></g><defs><clipPath id="cp"><rect width="40" height="40" fill="white" transform="translate(40) rotate(90)"/></clipPath></defs></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><g clip-path="url(#cn)"><path d="M33.86 6.14c7.65 7.66 7.65 20.07 0 27.72-7.66 7.66-20.07 7.66-27.72 0-7.66-7.66-7.66-20.07 0-27.72 7.65-7.66 20.06-7.66 27.72 0Z" fill="#513937"/><path d="M20.82 31.64l-1.66-1.66 8.7-8.72-20.16-.23.02-2.35 20.06.23-8.87-8.9 1.66-1.65L32.3 20.12 20.82 31.64Z" fill="#F8F4E4"/></g><defs><clipPath id="cn"><rect width="40" height="40" fill="white" transform="translate(40) rotate(90)"/></clipPath></defs></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '0px'
                    }
                }
            ]
        });
    }


    // ========== WOOCOMMERCE DOM READY UTILITIES ==========

    if (window.jQuery) {
        const $ = window.jQuery;

        jQuery(document).ready(function () {
            // Variation discount quantity input
            jQuery('.variation-Discount').closest('tr').find('.product-quantity').html(
                '<div class="minusbtn"><button disabled type="button" class="minus">-</button></div>' +
                '<div class="quantity"><input type="number" readonly class="input-text qty text" value="1" title="Qty" size="4"></div>' +
                '<div class="plusbtn"><button disabled type="button" class="plus">+</button></div>'
            );

            // Billing country change handler
            jQuery('#billing_country').on('change', function () {
                jQuery('.checkout-loader').show();
                jQuery(document.body).one('updated_checkout', function () {
                    window.location.reload();
                });
                jQuery(document.body).trigger('update_checkout');
            });

            // PayPal button toggle based on terms checkbox
            const $paypalButton = jQuery('.ppcp-dcc-order-button');
            if ($paypalButton.length) {
                const $checkbox = jQuery('input.woocommerce-form__input.woocommerce-form__input-checkbox, #terms');

                if ($checkbox.length) {
                    const togglePaypalButton = function () {
                        $paypalButton.prop('disabled', !$checkbox.is(':checked'));
                    };

                    togglePaypalButton();
                    $checkbox.on('change', togglePaypalButton);
                } else {
                    $paypalButton.prop('disabled', true);
                }
            }

            // Make donation field a number input
            jQuery('.wdgk_donation').prop('type', 'number');

            // Banner text background styling
            if (jQuery('.bannertext').length) {
                const greenBlockImageUrl = (window.location.origin || '') + '/wp-content/themes/workinganimals-content/images/greenblock.png';

                const calcBannerSize = function () {
                    const bannerTextWidth = jQuery('.bannertext').width();
                    jQuery('.bannertext').css('--banner-text-width', bannerTextWidth + 'px');

                    const bannerTextAfterStyle = `
                        position: absolute;
                        content: "";
                        background: url('${greenBlockImageUrl}') no-repeat;
                        background-size: 100% 100%;
                        width: calc(150% + var(--banner-text-width) + 55px)!important;
                        height: 100%;
                        left: -150%;
                        top: 0;
                        z-index: -1;
                    `;

                    jQuery('.bannertext').prev('style').remove();
                    jQuery('.bannertext').before('<style>.bannertext::after {' + bannerTextAfterStyle + '}</style>');
                };

                calcBannerSize();
                jQuery(window).on('resize', calcBannerSize);
            }

            // Cart dropdown toggle
            jQuery(document).on("click", '.cartclick,.mobilecartwrapper', function (e) {
                if (jQuery(e.target).closest('.cartdropdown').length) return;
                jQuery('.cartdropdown').slideToggle();
            });

            // Shop steps numbering on mobile
            var checkDown = jQuery('.wpmc-billing .wpmc-tab-number').text();
            jQuery('.wpmc-billing .wpmc-tab-number').text(+checkDown + 1);

            checkDown = jQuery('.wpmc-review .wpmc-tab-number').text();
            jQuery('.wpmc-review .wpmc-tab-number').text(+checkDown + 1);

            checkDown = jQuery('.wpmc-payment .wpmc-tab-number').text();
            jQuery('.wpmc-payment .wpmc-tab-number').text(+checkDown + 1);

            // Gift card placeholder
            jQuery("#ywgc-sender-name").attr("placeholder", "Your Name");

            // Cart URL update
            $pathName = document.location.pathname;
            $newCartUrl = $pathName.split('/').slice(0, -2).join('/') + '/cart';
            jQuery('.wpmc-tab-text a').attr('href', $newCartUrl);

            console.log($pathName);
            console.log($newCartUrl);

            // Add cart step
            jQuery("li.wpmc-billing:first-child").before(
                '<li class=""><div class="wpmc-tab-number">1</div><div class="wpmc-tab-text"><a href="">Cart</a></div></li>'
            );

            // Refresh page after cart upload
            jQuery(document.body).on('updated_cart_totals', function () {
                location.reload();
            });

            // Checkout country dropdown
            if (jQuery("#select2-billing_country-container").text() === "Select a country / region…" &&
                jQuery("#select2-billing_country-container").prop('title')
            ) {
                jQuery("#select2-billing_country-container").text(jQuery("#select2-billing_country-container").prop('title'));
            }

            // Empty gift card recipient note
            if (jQuery(".ywgc-empty-recipient-note").length) {
                jQuery(".ywgc-empty-recipient-note").text(`If the recipient's details are left blank, the e-card will be sent to your email address`);
                jQuery('.gift_card_template_button .quantity .qty').prop('disabled', true).css('background-color', 'lightgray');
            }

            // Donation rounding suggestion at checkout
            const ELEMENTS = {
                CART_FORM: 'woocommerce-cart-form',
                SUBTOTAL_CONTAINER: 'cart-subtotal',
                SUBTOTAL_AMOUNT: 'woocommerce-Price-amount',
                DONATION_INPUT: 'wdgk_donation'
            };

            if (jQuery(`.${ELEMENTS.CART_FORM}`).length > 0 && jQuery(`.${ELEMENTS.DONATION_INPUT}`).val() === '') {
                calculateDonationAmount(ELEMENTS);
            }
        });
    }

    /**
     * Populate the donation input with a calculated amount based on the subtotal of the customers basket,
     * rounded up to the nearest multiple of 5
     */
    function calculateDonationAmount(ELEMENTS) {
        if (!window.jQuery) return;
        const $ = window.jQuery;

        const $subtotalElement = jQuery(`.${ELEMENTS.SUBTOTAL_CONTAINER} .${ELEMENTS.SUBTOTAL_AMOUNT}`).text();

        if ($subtotalElement) {
            const subtotal = $subtotalElement.slice(1);

            if (subtotal % 5 !== 0) {
                const roundedTotal = Math.ceil(subtotal / 5) * 5;
                const donationAmount = (roundedTotal - subtotal).toFixed(2);
                jQuery(`.${ELEMENTS.DONATION_INPUT}`).val(donationAmount);
            }
        }
    }


    // ========== CUSTOM SELECT FILTER ==========

    var x, i, j, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < selElmnt.length; j++) {
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function (e) {
                var y, i, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }

    function closeAllSelect(elmnt) {
        var x, y, i, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    document.addEventListener("click", closeAllSelect);

    // Change the donate placeholder based on region
    if (window.jQuery) {
        const $ = window.jQuery;
        jQuery('.uk .wdgk_donation_content input[name="donation-price"]').attr('placeholder', 'EX.£5');
        jQuery('.au .wdgk_donation_content input[name="donation-price"]').attr('placeholder', 'EX.$10');

        // Change the gift card title
        jQuery('.gift-card-content-editor .ywgc-editor-section-title').text('e-gift details');

        // Remove categories filter
        jQuery(".productcatsort:contains('Categories')").html(function (_, html) {
            return html.replace(/(Categories)/g, '<span class="d-none">Categories</span>')
        });

        // Replace gift card button from select amount to read more
        jQuery(".product_type_gift-card.add_to_cart_button").text('Read more');

        // Move description above product detail on giftcard
    }
});